<cjm-tag-group>
	<li>
		<!-- min: 0 - max: 150: Not set -->
		@if (
			showNotSet &&
			targetAudience.minAge <= associationTargetAudience.MIN_AGE &&
			targetAudience.maxAge >= associationTargetAudience.DEFAULT_MAX_AGE
		) {
			<cjm-tag
				tagType="gray"
				cypressTag="TargetAudienceTags.AgeNotSet"
				[clearable]="clearable()"
				(clear)="clear.emit('age')"
			>
				{{ i18nKeys.TargetAudience.Age.Default | translate }}
			</cjm-tag>
		}

		<!-- min: 0 - max: 149: No restriction -->
		@if (
			targetAudience.minAge <= associationTargetAudience.MIN_AGE &&
			targetAudience.maxAge === associationTargetAudience.MAX_AGE
		) {
			<cjm-tag
				tagType="gray"
				cypressTag="TargetAudienceTags.AgeNoRestriction"
				[clearable]="clearable()"
				(clear)="clear.emit('age')"
			>
				{{ i18nKeys.TargetAudience.Age.NoAgeRestriction | translate }}
			</cjm-tag>
		}

		<!-- min: +0 - max: -149: min & max restriction -->
		@if (
			targetAudience.minAge > associationTargetAudience.MIN_AGE &&
			targetAudience.maxAge < associationTargetAudience.MAX_AGE
		) {
			<cjm-tag
				tagType="gray"
				cypressTag="TargetAudienceTags.AgeMinMaxRestriction"
				[clearable]="clearable()"
				(clear)="clear.emit('age')"
			>
				{{
					i18nKeys.TargetAudience.Age.FromTo
						| translate: { minAge: targetAudience.minAge, maxAge: targetAudience.maxAge }
				}}
			</cjm-tag>
		}

		<!-- min: +0 - max: +149: min restriction -->
		@if (
			targetAudience.minAge > associationTargetAudience.MIN_AGE &&
			targetAudience.maxAge >= associationTargetAudience.MAX_AGE
		) {
			<cjm-tag
				tagType="gray"
				cypressTag="TargetAudienceTags.AgeMinRestriction"
				[clearable]="clearable()"
				(clear)="clear.emit('age')"
			>
				{{ i18nKeys.TargetAudience.Age.From | translate: { minAge: targetAudience.minAge } }}
			</cjm-tag>
		}

		<!-- min: -0 - max: -149: max restriction -->
		@if (
			targetAudience.minAge <= associationTargetAudience.MIN_AGE &&
			targetAudience.maxAge < associationTargetAudience.MAX_AGE
		) {
			<cjm-tag
				tagType="gray"
				cypressTag="TargetAudienceTags.AgeMaxRestriction"
				[clearable]="clearable()"
				(clear)="clear.emit('age')"
			>
				{{ i18nKeys.TargetAudience.Age.UpTo | translate: { maxAge: targetAudience.maxAge } }}
			</cjm-tag>
		}
	</li>
</cjm-tag-group>
